module.exports = __webpack_public_path__ + "img/page.f68dc1b2.svg";